import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { EventsEntityGrid } from '../features/events-entity-grid';

export const AllEventsPage = observer(() => {
  return (
    <AppPage perm="PERM_JOURNAL_READ" noWrapper>
      <EventsEntityGrid />
    </AppPage>
  );
});
